import React, { useContext, useState } from "react";
import { Button } from "react-bootstrap";

import AuthenticatedUserContext from "../../context/AuthenticatedUserContext";
import ProfileAddressEditModal from "./ProfileAddressEditModal";
import { getCountryNameFromAlpha3 } from "../../utilities/countryUtils";

function ProfileAddressCard() {
    const { user } = useContext(AuthenticatedUserContext);
    const [showEditModal, setShowEditModal] = useState(false);

    const handleEdit = () => {
        setShowEditModal(true);
    };

    const handleCloseModal = () => {
        setShowEditModal(false);
    };

    // Get the country name in Dutch
    const countryName = user.country ? getCountryNameFromAlpha3(user.country) : null;

    return (
        <>
            <ProfileAddressEditModal 
                show={showEditModal} 
                handleClose={handleCloseModal} 
            />
            <div className="card mb-3">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h5 className="card-title">
                            Adresgegevens
                        </h5>
                        <Button variant="primary" onClick={handleEdit}>
                            Wijzigen
                        </Button>
                    </div>
                    <p className="card-text text-muted">
                        Deze gegevens staan opgeslagen in je DRVR account en worden gebruikt bij het aanmelden voor een evenement.
                    </p>
                    <p className="card-text">
                        <strong>Adres:</strong> {user.address ? user.address : <i className="text-muted">Niet ingevuld</i>}<br/>
                        <strong>Postcode:</strong> {user.postalCode ? user.postalCode : <i className="text-muted">Niet ingevuld</i>}<br/>
                        <strong>Stad:</strong> {user.city ? user.city : <i className="text-muted">Niet ingevuld</i>}<br/>
                        <strong>Land:</strong> {countryName ? countryName : <i className="text-muted">Niet ingevuld</i>}<br/>
                    </p>
                </div>
            </div>
        </>
    );
}

export default React.memo(ProfileAddressCard);
